import gql from "graphql-tag";

const addBotToChatGroupMutation = gql`
    mutation addBotToChatGroupMutation($chatGroupId: String, $universitySlug: String) {
        addBotToChatGroup(chatGroupId: $chatGroupId, universitySlug: $universitySlug) {
            chatGroup {
                id
                lastMessage {
                    text
                    created
                }
                unreadMessageCount
                members {
                    id
                    profilePhoto
                }
                opponent {
                    id
                    firstName
                    inboxInfoOne
                    inboxInfoTwo
                    profilePhoto
                    accountRole
                    isOnline
                }
            }
        }
    }
`;

export default addBotToChatGroupMutation;
